module.exports = __webpack_public_path__ + "img/play.a0daa16f.gif";